
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AdminCompanyLegalInformationResource,
  ClientLegalInformationRequest,
  CompanyIdentityBackfillStrategy,
  CompanyIdentityFinancingMigrationRequest,
  CompanyIdentityFinancingMigrationResponse,
  FinancingAnalysisViolationResource,
  LegalEntityFixStrategy,
} from '../models';
import {
    AdminCompanyLegalInformationResourceFromJSON,
    AdminCompanyLegalInformationResourceToJSON,
    ClientLegalInformationRequestFromJSON,
    ClientLegalInformationRequestToJSON,
    CompanyIdentityBackfillStrategyFromJSON,
    CompanyIdentityBackfillStrategyToJSON,
    CompanyIdentityFinancingMigrationRequestFromJSON,
    CompanyIdentityFinancingMigrationRequestToJSON,
    CompanyIdentityFinancingMigrationResponseFromJSON,
    CompanyIdentityFinancingMigrationResponseToJSON,
    FinancingAnalysisViolationResourceFromJSON,
    FinancingAnalysisViolationResourceToJSON,
    LegalEntityFixStrategyFromJSON,
    LegalEntityFixStrategyToJSON,
} from '../models';

export interface AssociateCompanyLegalInformationRequest {
    uniqueIdentifier?: string;
}

export interface BackfillCompanyLegalInformatioWithProjectRequest {
    limit: number;
    strategy: CompanyIdentityBackfillStrategy;
    legalEntityId?: string;
    countryCode?: string;
}

export interface BackfillCompanyLegalInformationRequest {
    limit: number;
    strategy: CompanyIdentityBackfillStrategy;
    countryCode: string;
    legalEntityId?: string;
}

export interface FixLegalEntitiesIdentificationRequest {
    mode: LegalEntityFixStrategy;
    limit: number;
    offset?: string;
}

export interface GetCompanyLegalInformationRequest {
    clientLegalInformationRequest: ClientLegalInformationRequest;
}

export interface RefreshCompanyLegalInformationRequest {
    clientLegalInformationRequest: ClientLegalInformationRequest;
}

export interface TriggerCompanyIdentityFinancingMigrationRequest {
    companyIdentityFinancingMigrationRequest: CompanyIdentityFinancingMigrationRequest;
}

/**
 * 
 */
export class AdminCompanyLegalInformationApi extends runtime.BaseAPI {

    /**
     * Assign company identities for legal company information without one
          */
    async associateCompanyLegalInformationRaw(requestParameters: AssociateCompanyLegalInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['uniqueIdentifier'] != null) {
            queryParameters['uniqueIdentifier'] = requestParameters['uniqueIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/legal-information/associate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Assign company identities for legal company information without one
          */
    async associateCompanyLegalInformation(requestParameters: AssociateCompanyLegalInformationRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.associateCompanyLegalInformationRaw(requestParameters, initOverrides);
    }

    /**
     * Create company identities and the corresponding  legal information restricted to teh list of legal entities associated with at least one project
          */
    async backfillCompanyLegalInformatioWithProjectRaw(requestParameters: BackfillCompanyLegalInformatioWithProjectRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling backfillCompanyLegalInformatioWithProject().'
            );
        }

        if (requestParameters['strategy'] == null) {
            throw new runtime.RequiredError(
                'strategy',
                'Required parameter "strategy" was null or undefined when calling backfillCompanyLegalInformatioWithProject().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['legalEntityId'] != null) {
            queryParameters['legalEntityId'] = requestParameters['legalEntityId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['strategy'] != null) {
            queryParameters['strategy'] = requestParameters['strategy'];
        }

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/legal-information/backfill-project`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Create company identities and the corresponding  legal information restricted to teh list of legal entities associated with at least one project
          */
    async backfillCompanyLegalInformatioWithProject(requestParameters: BackfillCompanyLegalInformatioWithProjectRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.backfillCompanyLegalInformatioWithProjectRaw(requestParameters, initOverrides);
    }

    /**
     * Create company identities and the corresponding  legal information
          */
    async backfillCompanyLegalInformationRaw(requestParameters: BackfillCompanyLegalInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling backfillCompanyLegalInformation().'
            );
        }

        if (requestParameters['strategy'] == null) {
            throw new runtime.RequiredError(
                'strategy',
                'Required parameter "strategy" was null or undefined when calling backfillCompanyLegalInformation().'
            );
        }

        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling backfillCompanyLegalInformation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['legalEntityId'] != null) {
            queryParameters['legalEntityId'] = requestParameters['legalEntityId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['strategy'] != null) {
            queryParameters['strategy'] = requestParameters['strategy'];
        }

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/legal-information/backfill`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Create company identities and the corresponding  legal information
          */
    async backfillCompanyLegalInformation(requestParameters: BackfillCompanyLegalInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.backfillCompanyLegalInformationRaw(requestParameters, initOverrides);
    }

    /**
     * Assign company identities for legal company information without one
          */
    async fixLegalEntitiesIdentificationRaw(requestParameters: FixLegalEntitiesIdentificationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['mode'] == null) {
            throw new runtime.RequiredError(
                'mode',
                'Required parameter "mode" was null or undefined when calling fixLegalEntitiesIdentification().'
            );
        }

        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling fixLegalEntitiesIdentification().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['mode'] != null) {
            queryParameters['mode'] = requestParameters['mode'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/legal-entity-identity/fix`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Assign company identities for legal company information without one
          */
    async fixLegalEntitiesIdentification(requestParameters: FixLegalEntitiesIdentificationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.fixLegalEntitiesIdentificationRaw(requestParameters, initOverrides);
    }

    /**
     * Get legal information for a client or freelancer company
          */
    async getCompanyLegalInformationRaw(requestParameters: GetCompanyLegalInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<AdminCompanyLegalInformationResource>>> {
        if (requestParameters['clientLegalInformationRequest'] == null) {
            throw new runtime.RequiredError(
                'clientLegalInformationRequest',
                'Required parameter "clientLegalInformationRequest" was null or undefined when calling getCompanyLegalInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<Array<AdminCompanyLegalInformationResource>>({
            path: `/compliance/api/admin/legal-information`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientLegalInformationRequestToJSON(requestParameters['clientLegalInformationRequest']),
        }, initOverrides);

        response._data=response._data?.map(AdminCompanyLegalInformationResourceFromJSON);
        return response;
    }

    /**
     * Get legal information for a client or freelancer company
          */
    async getCompanyLegalInformation(requestParameters: GetCompanyLegalInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<AdminCompanyLegalInformationResource>> {
        const response = await this.getCompanyLegalInformationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * List all detected financing analysis violations across all company identities
          */
    async listCompanyIdentityFinancingAnalysisViolationsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<FinancingAnalysisViolationResource>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<FinancingAnalysisViolationResource>>({
            path: `/compliance/api/admin/company-identity/financing-migration/violations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(FinancingAnalysisViolationResourceFromJSON);
        return response;
    }

    /**
     * List all detected financing analysis violations across all company identities
          */
    async listCompanyIdentityFinancingAnalysisViolations(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<FinancingAnalysisViolationResource>> {
        const response = await this.listCompanyIdentityFinancingAnalysisViolationsRaw(initOverrides);
        return response._data;
    }

    /**
     * Refresh legal information for a client or freelancer company
          */
    async refreshCompanyLegalInformationRaw(requestParameters: RefreshCompanyLegalInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['clientLegalInformationRequest'] == null) {
            throw new runtime.RequiredError(
                'clientLegalInformationRequest',
                'Required parameter "clientLegalInformationRequest" was null or undefined when calling refreshCompanyLegalInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/admin/legal-information/refresh`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientLegalInformationRequestToJSON(requestParameters['clientLegalInformationRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Refresh legal information for a client or freelancer company
          */
    async refreshCompanyLegalInformation(requestParameters: RefreshCompanyLegalInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.refreshCompanyLegalInformationRaw(requestParameters, initOverrides);
    }

    /**
     * Assign company identities for legal company information without one
          */
    async removeInvalidIdentificationsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/legal-entity-identity/remove-invalid`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Assign company identities for legal company information without one
          */
    async removeInvalidIdentifications(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.removeInvalidIdentificationsRaw(initOverrides);
    }

    /**
     * Trigger financing migration for company identities
          */
    async triggerCompanyIdentityFinancingMigrationRaw(requestParameters: TriggerCompanyIdentityFinancingMigrationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompanyIdentityFinancingMigrationResponse>> {
        if (requestParameters['companyIdentityFinancingMigrationRequest'] == null) {
            throw new runtime.RequiredError(
                'companyIdentityFinancingMigrationRequest',
                'Required parameter "companyIdentityFinancingMigrationRequest" was null or undefined when calling triggerCompanyIdentityFinancingMigration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<CompanyIdentityFinancingMigrationResponse>({
            path: `/compliance/api/admin/company-identity/financing-migration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyIdentityFinancingMigrationRequestToJSON(requestParameters['companyIdentityFinancingMigrationRequest']),
        }, initOverrides);

        if (response._data) { response._data=CompanyIdentityFinancingMigrationResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Trigger financing migration for company identities
          */
    async triggerCompanyIdentityFinancingMigration(requestParameters: TriggerCompanyIdentityFinancingMigrationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompanyIdentityFinancingMigrationResponse> {
        const response = await this.triggerCompanyIdentityFinancingMigrationRaw(requestParameters, initOverrides);
        return response._data;
    }

}
